const en = {
  hero: {
    title: 'Unlock Your Creative Potential with VGOT AI',
    subtitle: 'Choose the perfect plan to power your projects, from viral shorts to compelling digital human narratives.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    saveUp: 'Save 20%',
    noHiddenFees: 'Cancel anytime. No hidden fees.',
    startFree: 'Start for free',
    comparePlans: 'Compare plans',
  },
  plans: {
    labels: {
      mostPopular: 'Most Popular',
      coreFeatures: 'Core Features',
      monthlyCredits: 'Monthly Credits',
      expiresMonthly: 'expires monthly',
      billedMonthly: 'Billed monthly',
      billedYearly: 'Billed yearly',
      billed: 'Billed',
      save: 'Save',
      perMonth: '/ mo',
      year: 'yearly'
    },
    free: {
      name: 'Free',
      tagline: 'Experience',
      description: '200 credits on signup to test the workflow',
      cta: 'Get Started',
      credits: '0 (200 signup bonus)',
      features: {
        scriptGen: { label: 'Script Generation', value: 'Free (50/day)', free: true },
        characterImage: { label: 'Character Image', value: '50 credits/generation', checked: true },
        soraVideo: { label: 'HyperSell Video', value: '150 credits/generation', checked: true },
        digitalHuman: { label: 'SuperIP Video', value: 'Locked', locked: true },
        maxDuration: { label: 'Max Duration', value: 'N/A', locked: true },
        hdEnhance: { label: 'HD Enhancement', value: 'N/A', locked: true },
        voiceClone: { label: 'Voice Creation', value: 'N/A', locked: true },
        watermark: { label: 'Watermark-free Export', value: 'With watermark', locked: true },
        priorityQueue: { label: 'Priority Queue', value: 'Standard', locked: true },
        apiAccess: { label: 'API Access', value: 'N/A', locked: true },
      },
    },
    creator: {
      name: 'Creator',
      tagline: 'Pro',
      description: 'Perfect for individual creators and content teams',
      cta: 'Subscribe',
      price: { monthly: 29, yearly: 290 },
      credits: '30,000',
      features: {
        scriptGen: { label: 'Script Generation', value: 'Unlimited', unlimited: true },
        characterImage: { label: 'Character Image', value: '50 credits/generation', checked: true },
        soraVideo: { label: 'HyperSell Video', value: '150 credits/generation', checked: true },
        digitalHuman: { label: 'SuperIP Video', value: '70 credits/second', checked: true },
        maxDuration: { label: 'Max Duration', value: '2 minutes', checked: true },
        hdEnhance: { label: 'HD Enhancement', value: '800 credits/time', discount: true },
        voiceClone: { label: 'Voice Creation', value: '3000 credits/voice', checked: true },
        watermark: { label: 'Watermark-free Export', value: 'Yes', checked: true },
        priorityQueue: { label: 'Priority Queue', value: 'High-speed', checked: true },
        apiAccess: { label: 'API Access', value: 'N/A', locked: true },
      },
    },
    business: {
      name: 'Business',
      tagline: 'Commercial',
      description: 'For agencies and growing e-commerce brands',
      cta: 'Go Business',
      price: { monthly: 99, yearly: 990 },
      credits: '120,000',
      popular: true,
      features: {
        scriptGen: { label: 'Script Generation', value: 'Unlimited', unlimited: true },
        characterImage: { label: 'Character Image', value: 'Free Unlimited', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell Video', value: '150 credits/generation', checked: true },
        digitalHuman: { label: 'SuperIP Video', value: '70 credits/second', checked: true },
        maxDuration: { label: 'Max Duration', value: '10 minutes', checked: true },
        hdEnhance: { label: 'HD Enhancement', value: '500 credits (40% off)', discount: true },
        voiceClone: { label: 'Voice Creation', value: 'First free', gift: true },
        watermark: { label: 'Watermark-free Export', value: 'Yes', checked: true },
        priorityQueue: { label: 'Priority Queue', value: 'High-speed', checked: true },
        apiAccess: { label: 'API Access', value: 'N/A', locked: true },
      },
    },
    enterprise: {
      name: 'Enterprise',
      tagline: 'Enterprise',
      price: 'Custom',
      description: 'Custom solutions for large teams and platforms',
      cta: 'Contact Sales',
      credits: 'Custom quota',
      features: {
        scriptGen: { label: 'Script Generation', value: 'Unlimited', unlimited: true },
        characterImage: { label: 'Character Image', value: 'Free Unlimited', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell Video', value: '150 credits/generation', checked: true },
        digitalHuman: { label: 'SuperIP Video', value: 'Custom rate', custom: true },
        maxDuration: { label: 'Max Duration', value: 'Unlimited/Custom', unlimited: true },
        hdEnhance: { label: 'HD Enhancement', value: 'Custom discount', discount: true, custom: true },
        voiceClone: { label: 'Voice Creation', value: 'On-demand gift', gift: true, custom: true },
        watermark: { label: 'Watermark-free Export', value: 'Yes', checked: true },
        priorityQueue: { label: 'Priority Queue', value: 'Highest priority', checked: true },
        apiAccess: { label: 'API Access', value: 'Full API', checked: true },
      },
    },
  },
  fullComparison: {
    title: 'Full Benefits Comparison',
    subtitle: 'Choose the plan that suits you best and unlock more creative possibilities',
    back: 'Back',
  },
  comparison: {
    title: 'Compare plans',
    subtitle: 'See which plan fits your current stage. You can upgrade or downgrade anytime.',
    featureLabel: 'Feature',
    customLabel: 'Custom',
    features: {
      monthlyPrice: 'Monthly Price',
      monthlyCredits: 'Monthly Credits',
      signupBonus: '0 (200 signup bonus)',
      scriptGeneration: 'Script Generation',
      roleGeneration: 'Role Generation',
      characterImage: 'Character Image',
      video: 'HyperSell Video',
      digitalHuman: 'SuperIP Video',
      durationLimit: 'Duration Limit',
      hdEnhancement: 'HD Enhancement',
      voiceCloning: 'Voice Creation',
      watermarkFree: 'Watermark-free Export',
      priorityQueue: 'Priority Queue',
      apiAccess: 'API Access',
      unlimited: 'Unlimited',
      freeLimit: 'Free (50/day)',
      unlimitedDemand: 'Unlimited / On-demand',
      creditsPerImage: '50 credits/image',
      creditsPerVideo: '150 credits/video',
      creditsPerSecond: '70 credits/sec',
      creditsPerEnhance: '800 credits/time',
      creditsPerVoice: '3000 credits/voice',
      freeUnlimited: 'Free Unlimited',
      customRate: 'Custom rate',
      twoMinutes: '2 minutes',
      tenMinutes: '10 minutes',
      customUnlimited: 'Custom / Unlimited',
      discountEnhance: '500 credits (discount)',
      customDiscount: 'Custom discount',
      firstFree: 'First free',
      batchGift: 'Batch gift',
    },
  },
  credits: {
    title: 'How VGOT credits work',
    description: 'VGOT uses credits so you don\'t have to think about individual API costs. Different actions consume different amounts of credits. For example:',
    examples: {
      soraVideo: 'Generate a HyperSell video',
      enhance: 'Enhance & upscale a video',
      talkingAvatar: 'Create a Super IP talking-avatar clip',
    },
    footnote: 'Your plan includes a monthly credit allowance. You can always buy extra credits if you need a spike for a campaign or launch.',
  },
  faq: {
    title: 'Pricing FAQ',
    q1: {
      question: 'How are credits consumed?',
      answer: '1 HyperSell Video = 150 credits, 1 Digital Human second = 70 credits, Character Image = 50 credits, HD Enhancement = 500-800 credits depending on plan. See full rates in your dashboard.',
    },
    q2: {
      question: 'What if I run out of credits?',
      answer: 'You can purchase additional credit packs anytime inside VGOT. Credits never expire, so you can stock up for busy campaigns.',
    },
    q3: {
      question: 'Can I upgrade/downgrade my plan?',
      answer: 'Yes, you can modify your subscription at any time. Upgrades take effect immediately, downgrades at the next billing cycle.',
    },
    q4: {
      question: 'What does "Free Unlimited Image Generation" mean?',
      answer: 'Business and Enterprise plans can create as many digital human character images as needed without consuming credits - perfect for building your avatar library.',
    },
    q5: {
      question: 'Do I get commercial rights to use the videos?',
      answer: 'All paid plans (Creator, Business, Enterprise) include full commercial usage rights for the content you create and export.',
    },
  },
};

const zhCN = {
  hero: {
    // Updated title per request: align with English "Unlock Your Creative Potential with VGOT AI"
    title: '使用 VGOT AI 解锁您的创意潜力',
    // Updated subtitle per request
    subtitle: '选择适合您的计划，从病毒短片到引人入胜的数字人类叙事。',
    monthly: '按月',
    yearly: '按年',
    saveUp: '节省 20%',
    noHiddenFees: '随时取消。无隐藏费用。',
    startFree: '免费开始',
    comparePlans: '比较计划',
  },
  plans: {
    labels: {
      mostPopular: '最受欢迎',
      coreFeatures: '核心功能',
      monthlyCredits: '每月积分',
      expiresMonthly: '每月过期',
      billedMonthly: '按月计费',
      billedYearly: '按年计费',
      billed: '计费',
      save: '省',
      perMonth: '/ 月',
      year: '年'
    },
    free: {
      name: '免费',
      tagline: '体验',
      description: '注册即送 200 积分测试工作流',
      cta: '开始使用',
      credits: '0 (200 注册赠送)',
      features: {
        scriptGen: { label: '脚本生成', value: '免费 (50/天)', free: true },
        characterImage: { label: '角色图像', value: '50 积分/次', checked: true },
        soraVideo: { label: 'HyperSell 视频', value: '150 积分/次', checked: true },
        digitalHuman: { label: 'SuperIP 视频', value: '未解锁', locked: true },
        maxDuration: { label: '最大时长', value: 'N/A', locked: true },
        hdEnhance: { label: '高清增强', value: 'N/A', locked: true },
        voiceClone: { label: '声音创建', value: 'N/A', locked: true },
        watermark: { label: '无水印导出', value: '带水印', locked: true },
        priorityQueue: { label: '优先队列', value: '标准', locked: true },
        apiAccess: { label: 'API 访问', value: 'N/A', locked: true },
      },
    },
    creator: {
      name: '创作者',
      tagline: '专业版',
      description: '适合个人创作者和内容团队',
      cta: '订阅',
      price: { monthly: 29, yearly: 290 },
      credits: '30,000',
      features: {
        scriptGen: { label: '脚本生成', value: '无限', unlimited: true },
        characterImage: { label: '角色图像', value: '50 积分/次', checked: true },
        soraVideo: { label: 'HyperSell 视频', value: '150 积分/次', checked: true },
        digitalHuman: { label: 'SuperIP 视频', value: '70 积分/秒', checked: true },
        maxDuration: { label: '最大时长', value: '2 分钟', checked: true },
        hdEnhance: { label: '高清增强', value: '800 积分/次', discount: true },
        voiceClone: { label: '声音创建', value: '3000 积分/声音', checked: true },
        watermark: { label: '无水印导出', value: '是', checked: true },
        priorityQueue: { label: '优先队列', value: '高速', checked: true },
        apiAccess: { label: 'API 访问', value: 'N/A', locked: true },
      },
    },
    business: {
      name: '商业版',
      tagline: '商业',
      description: '适合代理机构和成长型电商品牌',
      cta: '选择商业版',
      price: { monthly: 99, yearly: 990 },
      credits: '120,000',
      popular: true,
      features: {
        scriptGen: { label: '脚本生成', value: '无限', unlimited: true },
        characterImage: { label: '角色图像', value: '免费无限', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell 视频', value: '150 积分/次', checked: true },
        digitalHuman: { label: 'SuperIP 视频', value: '70 积分/秒', checked: true },
        maxDuration: { label: '最大时长', value: '10 分钟', checked: true },
        hdEnhance: { label: '高清增强', value: '500 积分 (6折)', discount: true },
        voiceClone: { label: '声音创建', value: '首个免费', gift: true },
        watermark: { label: '无水印导出', value: '是', checked: true },
        priorityQueue: { label: '优先队列', value: '高速', checked: true },
        apiAccess: { label: 'API 访问', value: 'N/A', locked: true },
      },
    },
    enterprise: {
      name: '企业版',
      tagline: '企业',
      price: '自定义',
      description: '适合大型团队和平台的自定义解决方案',
      cta: '联系销售',
      credits: '自定义配额',
      features: {
        scriptGen: { label: '脚本生成', value: '无限', unlimited: true },
        characterImage: { label: '角色图像', value: '免费无限', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell 视频', value: '150 积分/次', checked: true },
        digitalHuman: { label: 'SuperIP 视频', value: '自定义费率', custom: true },
        maxDuration: { label: '最大时长', value: '无限/自定义', unlimited: true },
        hdEnhance: { label: '高清增强', value: '自定义折扣', discount: true, custom: true },
        voiceClone: { label: '声音创建', value: '按需赠送', gift: true, custom: true },
        watermark: { label: '无水印导出', value: '是', checked: true },
        priorityQueue: { label: '优先队列', value: '最高优先级', checked: true },
        apiAccess: { label: 'API 访问', value: '完整 API', checked: true },
      },
    },
  },
  fullComparison: {
    title: '完整功能比较',
    subtitle: '选择最适合您的计划，解锁更多创意可能性',
    back: '返回',
  },
  comparison: {
    title: '比较计划',
    subtitle: '查看哪个计划适合您当前的阶段。您可以随时升级或降级。',
    featureLabel: '功能',
    customLabel: '自定义',
    features: {
      monthlyPrice: '月度价格',
      monthlyCredits: '每月积分',
      signupBonus: '0 (200 注册赠送)',
      scriptGeneration: '脚本生成',
      roleGeneration: '角色生成',
      characterImage: '角色图像',
      video: 'HyperSell 视频',
      digitalHuman: 'SuperIP 视频',
      durationLimit: '时长限制',
      hdEnhancement: '高清增强',
      voiceCloning: '声音创建',
      watermarkFree: '无水印导出',
      priorityQueue: '优先队列',
      apiAccess: 'API 访问',
      unlimited: '无限',
      freeLimit: '免费 (50/天)',
      unlimitedDemand: '无限 / 按需',
      creditsPerImage: '50 积分/图',
      creditsPerVideo: '150 积分/视频',
      creditsPerSecond: '70 积分/秒',
      creditsPerEnhance: '800 积分/次',
      creditsPerVoice: '3000 积分/声音',
      freeUnlimited: '免费无限',
      customRate: '自定义费率',
      twoMinutes: '2 分钟',
      tenMinutes: '10 分钟',
      customUnlimited: '自定义 / 无限',
      discountEnhance: '500 积分 (折扣)',
      customDiscount: '自定义折扣',
      firstFree: '首个免费',
      batchGift: '批量赠送',
    },
  },
  credits: {
    title: 'VGOT 积分如何工作',
    description: 'VGOT 使用积分，因此您无需考虑单独的 API 成本。不同的操作消耗不同数量的积分。例如：',
    examples: {
      soraVideo: '生成一个 HyperSell 视频',
      enhance: '增强和放大视频',
      talkingAvatar: '创建一个 Super IP 数字人片段',
    },
    footnote: '您的计划包含每月积分额度。如果您需要为活动或发布增加积分，您可以随时购买额外积分。',
  },
  faq: {
    title: '定价常见问题',
    q1: {
      question: '积分如何消耗？',
      answer: '1 HyperSell 视频 = 150 积分，1 秒数字人 = 70 积分，角色图像 = 50 积分，高清增强 = 500-800 积分（取决于计划）。在您的仪表板中查看完整费率。',
    },
    q2: {
      question: '如果我用完了积分怎么办？',
      answer: '您可以随时在 VGOT 内购买额外的积分包。积分永不过期，因此您可以为繁忙的活动囤积积分。',
    },
    q3: {
      question: '我可以升级/降级我的计划吗？',
      answer: '是的，您可以随时修改您的订阅。升级立即生效，降级在下一个计费周期生效。',
    },
    q4: {
      question: '“免费无限图像生成”是什么意思？',
      answer: '商业版和企业版计划可以根据需要创建任意数量的数字人角色图像，而无需消耗积分 - 非常适合建立您的头像库。',
    },
    q5: {
      question: '我拥有使用视频的商业权利吗？',
      answer: '所有付费计划（创作者、商业版、企业版）都包含您创建和导出的内容的完整商业使用权。',
    },
  },
};

const zhTW = {
  hero: {
    // Updated title to match requested wording (Traditional Chinese)
    title: '使用 VGOT AI 解鎖您的創意潛力',
    // Updated subtitle per request (Traditional Chinese)
    subtitle: '選擇適合您的計劃，從病毒短片到引人入勝的數位人類敘事。',
    monthly: '按月',
    yearly: '按年',
    saveUp: '節省 20%',
    noHiddenFees: '隨時取消。無隱藏費用。',
    startFree: '免費開始',
    comparePlans: '比較計劃',
  },
  plans: {
    labels: {
      mostPopular: '最受歡迎',
      coreFeatures: '核心功能',
      monthlyCredits: '每月積分',
      expiresMonthly: '每月過期',
      billedMonthly: '按月計費',
      billedYearly: '按年計費',
      billed: '計費',
      save: '省',
      perMonth: '/ 月',
      year: '年'
    },
    free: {
      name: '免費',
      tagline: '體驗',
      description: '註冊即送 200 積分測試工作流',
      cta: '開始使用',
      credits: '0 (200 註冊贈送)',
      features: {
        scriptGen: { label: '腳本生成', value: '免費 (50/天)', free: true },
        characterImage: { label: '角色圖像', value: '50 積分/次', checked: true },
        soraVideo: { label: 'HyperSell 影片', value: '150 積分/次', checked: true },
        digitalHuman: { label: 'SuperIP 影片', value: '未解鎖', locked: true },
        maxDuration: { label: '最大時長', value: 'N/A', locked: true },
        hdEnhance: { label: '高清增強', value: 'N/A', locked: true },
        voiceClone: { label: '聲音創建', value: 'N/A', locked: true },
        watermark: { label: '無水印導出', value: '帶水印', locked: true },
        priorityQueue: { label: '優先隊列', value: '標準', locked: true },
        apiAccess: { label: 'API 訪問', value: 'N/A', locked: true },
      },
    },
    creator: {
      name: '創作者',
      tagline: '專業版',
      description: '適合個人創作者和內容團隊',
      cta: '訂閱',
      price: { monthly: 29, yearly: 290 },
      credits: '30,000',
      features: {
        scriptGen: { label: '腳本生成', value: '無限', unlimited: true },
        characterImage: { label: '角色圖像', value: '50 積分/次', checked: true },
        soraVideo: { label: 'HyperSell 影片', value: '150 積分/次', checked: true },
        digitalHuman: { label: 'SuperIP 影片', value: '70 積分/秒', checked: true },
        maxDuration: { label: '最大時長', value: '2 分鐘', checked: true },
        hdEnhance: { label: '高清增強', value: '800 積分/次', discount: true },
        voiceClone: { label: '聲音創建', value: '3000 積分/聲音', checked: true },
        watermark: { label: '無水印導出', value: '是', checked: true },
        priorityQueue: { label: '優先隊列', value: '高速', checked: true },
        apiAccess: { label: 'API 訪問', value: 'N/A', locked: true },
      },
    },
    business: {
      name: '商業版',
      tagline: '商業',
      description: '適合代理機構和成長型電商品牌',
      cta: '選擇商業版',
      price: { monthly: 99, yearly: 990 },
      credits: '120,000',
      popular: true,
      features: {
        scriptGen: { label: '腳本生成', value: '無限', unlimited: true },
        characterImage: { label: '角色圖像', value: '免費無限', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell 影片', value: '150 積分/次', checked: true },
        digitalHuman: { label: 'SuperIP 影片', value: '70 積分/秒', checked: true },
        maxDuration: { label: '最大時長', value: '10 分鐘', checked: true },
        hdEnhance: { label: '高清增強', value: '500 積分 (6折)', discount: true },
        voiceClone: { label: '聲音創建', value: '首個免費', gift: true },
        watermark: { label: '無水印導出', value: '是', checked: true },
        priorityQueue: { label: '優先隊列', value: '高速', checked: true },
        apiAccess: { label: 'API 訪問', value: 'N/A', locked: true },
      },
    },
    enterprise: {
      name: '企業版',
      tagline: '企業',
      price: '自定義',
      description: '適合大型團隊和平台的自定義解決方案',
      cta: '聯繫銷售',
      credits: '自定義配額',
      features: {
        scriptGen: { label: '腳本生成', value: '無限', unlimited: true },
        characterImage: { label: '角色圖像', value: '免費無限', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell 影片', value: '150 積分/次', checked: true },
        digitalHuman: { label: 'SuperIP 影片', value: '自定義費率', custom: true },
        maxDuration: { label: '最大時長', value: '無限/自定義', unlimited: true },
        hdEnhance: { label: '高清增強', value: '自定義折扣', discount: true, custom: true },
        voiceClone: { label: '聲音創建', value: '按需贈送', gift: true, custom: true },
        watermark: { label: '無水印導出', value: '是', checked: true },
        priorityQueue: { label: '優先隊列', value: '最高優先級', checked: true },
        apiAccess: { label: 'API 訪問', value: '完整 API', checked: true },
      },
    },
  },
  fullComparison: {
    title: '完整功能比較',
    subtitle: '選擇最適合您的計劃，解鎖更多創意可能性',
    back: '返回',
  },
  comparison: {
    title: '比較計劃',
    subtitle: '查看哪個計劃適合您當前的階段。您可以隨時升級或降級。',
    featureLabel: '功能',
    customLabel: '自定義',
    features: {
      monthlyPrice: '月度價格',
      monthlyCredits: '每月積分',
      signupBonus: '0 (200 註冊贈送)',
      scriptGeneration: '腳本生成',
      roleGeneration: '角色生成',
      characterImage: '角色圖像',
      video: 'HyperSell 影片',
      digitalHuman: 'SuperIP 影片',
      durationLimit: '時長限制',
      hdEnhancement: '高清增強',
      voiceCloning: '聲音創建',
      watermarkFree: '無水印導出',
      priorityQueue: '優先隊列',
      apiAccess: 'API 訪問',
      unlimited: '無限',
      freeLimit: '免費 (50/天)',
      unlimitedDemand: '無限 / 按需',
      creditsPerImage: '50 積分/圖',
      creditsPerVideo: '150 積分/影片',
      creditsPerSecond: '70 積分/秒',
      creditsPerEnhance: '800 積分/次',
      creditsPerVoice: '3000 積分/聲音',
      freeUnlimited: '免費無限',
      customRate: '自定義費率',
      twoMinutes: '2 分鐘',
      tenMinutes: '10 分鐘',
      customUnlimited: '自定義 / 無限',
      discountEnhance: '500 積分 (折扣)',
      customDiscount: '自定義折扣',
      firstFree: '首個免費',
      batchGift: '批量贈送',
    },
  },
  credits: {
    title: 'VGOT 積分如何工作',
    description: 'VGOT 使用積分，因此您無需考慮單獨的 API 成本。不同的操作消耗不同數量的積分。例如：',
    examples: {
      soraVideo: '生成一個 HyperSell 影片',
      enhance: '增強和放大影片',
      talkingAvatar: '創建一個 Super IP 數字人片段',
    },
    footnote: '您的計劃包含每月積分額度。如果您需要為活動或發布增加積分，您可以隨時購買額外積分。',
  },
  faq: {
    title: '定價常見問題',
    q1: {
      question: '積分如何消耗？',
      answer: '1 HyperSell 影片 = 150 積分，1 秒數字人 = 70 積分，角色圖像 = 50 積分，高清增強 = 500-800 積分（取決於計劃）。在您的儀表板中查看完整費率。',
    },
    q2: {
      question: '如果我用完了積分怎麼辦？',
      answer: '您可以隨時在 VGOT 內購買額外的積分包。積分永不過期，因此您可以為繁忙的活動囤積積分。',
    },
    q3: {
      question: '我可以升級/降級我的計劃嗎？',
      answer: '是的，您可以隨時修改您的訂閱。升級立即生效，降級在下一個計費週期生效。',
    },
    q4: {
      question: '“免費無限圖像生成”是什麼意思？',
      answer: '商業版和企業版計劃可以根據需要創建任意數量的數字人角色圖像，而無需消耗積分 - 非常適合建立您的頭像庫。',
    },
    q5: {
      question: '我擁有使用影片的商業權利嗎？',
      answer: '所有付費計劃（創作者、商業版、企業版）都包含您創建和導出的內容的完整商業使用權。',
    },
  },
};

const es = {
  hero: {
    title: 'Desbloquea tu potencial creativo con VGOT AI',
    subtitle: 'Elige el plan perfecto para impulsar tus proyectos, desde cortos virales hasta narrativas con humanos digitales.',
    monthly: 'Mensual',
    yearly: 'Anual',
    saveUp: 'Ahorra 20%',
    noHiddenFees: 'Cancela cuando quieras. Sin tarifas ocultas.',
    startFree: 'Comenzar gratis',
    comparePlans: 'Comparar planes',
  },
  plans: {
    labels: {
      mostPopular: 'Más Popular',
      coreFeatures: 'Características principales',
      monthlyCredits: 'Créditos mensuales',
      expiresMonthly: 'caduca mensualmente',
      billedMonthly: 'Facturado mensualmente',
      billedYearly: 'Facturado anualmente',
      billed: 'Facturado',
      save: 'Ahorra',
      perMonth: '/ mes',
      year: 'anual'
    },
    free: {
      name: 'Gratis',
      tagline: 'Experiencia',
      description: '200 créditos al registrarte para probar el flujo de trabajo',
      cta: 'Comenzar',
      credits: '0 (200 de bono de registro)',
      billedMonthly: 'Facturado mensualmente',
      billedYearly: 'Facturado anualmente',
      features: {
        scriptGen: { label: 'Generación de guiones', value: 'Gratis (50/día)', free: true },
        characterImage: { label: 'Imagen de personaje', value: '50 créditos/generación', checked: true },
        soraVideo: { label: 'Vídeo HyperSell', value: '150 créditos/generación', checked: true },
        digitalHuman: { label: 'Vídeo SuperIP', value: 'Bloqueado', locked: true },
        maxDuration: { label: 'Duración máxima', value: 'N/A', locked: true },
        hdEnhance: { label: 'Mejora HD', value: 'N/A', locked: true },
        voiceClone: { label: 'Creación de voz', value: 'N/A', locked: true },
        watermark: { label: 'Exportación sin marca de agua', value: 'Con marca de agua', locked: true },
        priorityQueue: { label: 'Cola de prioridad', value: 'Estándar', locked: true },
        apiAccess: { label: 'Acceso a API', value: 'N/A', locked: true },
      },
    },
    creator: {
      name: 'Creator',
      tagline: 'Pro',
      description: 'Perfecto para creadores individuales y equipos de contenido',
      cta: 'Suscribirse',
      price: { monthly: 29, yearly: 290 },
      credits: '30,000',
      features: {
        scriptGen: { label: 'Generación de guiones', value: 'Ilimitado', unlimited: true },
        characterImage: { label: 'Imagen de personaje', value: '50 créditos/generación', checked: true },
        soraVideo: { label: 'Vídeo HyperSell', value: '150 créditos/generación', checked: true },
        digitalHuman: { label: 'Vídeo SuperIP', value: '70 créditos/segundo', checked: true },
        maxDuration: { label: 'Duración máxima', value: '2 minutos', checked: true },
        hdEnhance: { label: 'Mejora HD', value: '800 créditos/vez', discount: true },
        voiceClone: { label: 'Creación de voz', value: '3000 créditos/voz', checked: true },
        watermark: { label: 'Exportación sin marca de agua', value: 'Sí', checked: true },
        priorityQueue: { label: 'Cola de prioridad', value: 'Alta velocidad', checked: true },
        apiAccess: { label: 'Acceso a API', value: 'N/A', locked: true },
      },
    },
    business: {
      name: 'Business',
      tagline: 'Comercial',
      description: 'Para agencias y marcas de e‑commerce en crecimiento',
      cta: 'Ir a Business',
      price: { monthly: 99, yearly: 990 },
      credits: '120,000',
      popular: true,
      features: {
        scriptGen: { label: 'Generación de guiones', value: 'Ilimitado', unlimited: true },
        characterImage: { label: 'Imagen de personaje', value: 'Ilimitado gratuito', free: true, unlimited: true },
        soraVideo: { label: 'Vídeo HyperSell', value: '150 créditos/generación', checked: true },
        digitalHuman: { label: 'Vídeo SuperIP', value: '70 créditos/segundo', checked: true },
        maxDuration: { label: 'Duración máxima', value: '10 minutos', checked: true },
        hdEnhance: { label: 'Mejora HD', value: '500 créditos (40% de descuento)', discount: true },
        voiceClone: { label: 'Creación de voz', value: 'Primero gratis', gift: true },
        watermark: { label: 'Exportación sin marca de agua', value: 'Sí', checked: true },
        priorityQueue: { label: 'Cola de prioridad', value: 'Alta velocidad', checked: true },
        apiAccess: { label: 'Acceso a API', value: 'N/A', locked: true },
      },
    },
    enterprise: {
      name: 'Enterprise',
      tagline: 'Empresa',
      price: 'Personalizado',
      description: 'Soluciones personalizadas para equipos grandes y plataformas',
      cta: 'Contactar ventas',
      credits: 'Cuota personalizada',
      features: {
        scriptGen: { label: 'Generación de guiones', value: 'Ilimitado', unlimited: true },
        characterImage: { label: 'Imagen de personaje', value: 'Ilimitado gratuito', free: true, unlimited: true },
        soraVideo: { label: 'Vídeo HyperSell', value: '150 créditos/generación', checked: true },
        digitalHuman: { label: 'Vídeo SuperIP', value: 'Tarifa personalizada', custom: true },
        maxDuration: { label: 'Duración máxima', value: 'Ilimitado/Personalizado', unlimited: true },
        hdEnhance: { label: 'Mejora HD', value: 'Descuento personalizado', discount: true, custom: true },
        voiceClone: { label: 'Creación de voz', value: 'Regalo bajo demanda', gift: true, custom: true },
        watermark: { label: 'Exportación sin marca de agua', value: 'Sí', checked: true },
        priorityQueue: { label: 'Cola de prioridad', value: 'Prioridad más alta', checked: true },
        apiAccess: { label: 'Acceso a API', value: 'API completa', checked: true },
      },
    },
  },
  fullComparison: {
    title: 'Comparación Completa de Beneficios',
    subtitle: 'Elige el plan que mejor se adapte a ti y desbloquea más posibilidades creativas',
    back: 'Volver',
  },
  comparison: {
    title: 'Comparar planes',
    subtitle: 'Ve qué plan se ajusta a tu etapa actual. Puedes actualizar o cambiar en cualquier momento.',
    featureLabel: 'Característica',
    customLabel: 'Personalizado',
    features: {
      monthlyPrice: 'Precio mensual',
      monthlyCredits: 'Créditos mensuales',
      signupBonus: '0 (200 de bono de registro)',
      scriptGeneration: 'Generación de guiones',
      roleGeneration: 'Generación de roles',
      characterImage: 'Imagen de personaje',
      video: 'Vídeo HyperSell',
      digitalHuman: 'Vídeo SuperIP',
      durationLimit: 'Límite de duración',
      hdEnhancement: 'Mejora HD',
      voiceCloning: 'Creación de voz',
      watermarkFree: 'Exportación sin marca de agua',
      priorityQueue: 'Cola de prioridad',
      apiAccess: 'Acceso a API',
      unlimited: 'Ilimitado',
      freeLimit: 'Gratis (50/día)',
      unlimitedDemand: 'Ilimitado / Bajo demanda',
      creditsPerImage: '50 créditos/imagen',
      creditsPerVideo: '150 créditos/vídeo',
      creditsPerSecond: '70 créditos/segundo',
      creditsPerEnhance: '800 créditos/vez',
      creditsPerVoice: '3000 créditos/voz',
      freeUnlimited: 'Ilimitado gratuito',
      customRate: 'Tarifa personalizada',
      twoMinutes: '2 minutos',
      tenMinutes: '10 minutos',
      customUnlimited: 'Personalizado / Ilimitado',
      discountEnhance: '500 créditos (descuento)',
      customDiscount: 'Descuento personalizado',
      firstFree: 'Primero gratis',
      batchGift: 'Regalo por lote',
    },
  },
  credits: {
    title: 'Cómo funcionan los créditos de VGOT',
    description: 'VGOT utiliza créditos para que no tengas que pensar en costos individuales de API. Acciones distintas consumen cantidades distintas de créditos. Por ejemplo:',
    examples: {
      soraVideo: 'Generar un vídeo HyperSell',
      enhance: 'Mejorar y reescalar un vídeo',
      talkingAvatar: 'Crear un clip de avatar parlante Super IP',
    },
    footnote: 'Tu plan incluye una asignación mensual de créditos. Siempre puedes comprar créditos extra si necesitas un pico para una campaña o lanzamiento.',
  },
  faq: {
    title: 'Preguntas frecuentes sobre precios',
    q1: {
      question: '¿Cómo se consumen los créditos?',
      answer: '1 Vídeo HyperSell = 150 créditos, 1 segundo de humano digital = 70 créditos, Imagen de personaje = 50 créditos, Mejora HD = 500–800 créditos según el plan. Revisa las tarifas completas en tu panel.',
    },
    q2: {
      question: '¿Qué pasa si me quedo sin créditos?',
      answer: 'Puedes comprar paquetes adicionales de créditos en cualquier momento dentro de VGOT. Los créditos no caducan, así que puedes acumular para campañas intensas.',
    },
    q3: {
      question: '¿Puedo actualizar o degradar mi plan?',
      answer: 'Sí. Puedes modificar tu suscripción cuando quieras. Las actualizaciones son inmediatas; las bajadas aplican en el próximo ciclo de facturación.',
    },
    q4: {
      question: '¿Qué significa “Generación ilimitada gratuita de imágenes”?',
      answer: 'Los planes Business y Enterprise pueden crear tantas imágenes de personajes como necesiten sin consumir créditos; ideal para construir tu biblioteca de avatares.',
    },
    q5: {
      question: '¿Tengo derechos comerciales para usar los vídeos?',
      answer: 'Todos los planes de pago (Creator, Business, Enterprise) incluyen derechos comerciales completos para el contenido que crees y exportes.',
    },
  },
};

const ja = {
  hero: {
    title: 'VGOT AIで創造力を解き放とう',
    subtitle: 'バイラルなショートから魅力的なデジタルヒューマンの物語まで、プロジェクトに最適なプランをお選びください。',
    monthly: '月払い',
    yearly: '年払い',
    saveUp: '20%お得',
    noHiddenFees: 'いつでも解約可。追加料金なし。',
    startFree: '無料ではじめる',
    comparePlans: 'プランを比較',
  },
  plans: {
    labels: {
      mostPopular: '一番人気',
      coreFeatures: '主要機能',
      monthlyCredits: '月間クレジット',
      expiresMonthly: '毎月失効',
      billedMonthly: '月次請求',
      billedYearly: '年間請求',
      billed: '請求',
      save: 'お得',
      perMonth: '/ 月',
      year: '年額'
    },
    free: {
      name: '無料',
      tagline: '体験',
      description: '登録時に200クレジット進呈。ワークフローをお試しください',
      cta: 'はじめる',
      credits: '0（登録ボーナス200）',
      features: {
        scriptGen: { label: 'スクリプト生成', value: '無料（1日50回）', free: true },
        characterImage: { label: 'キャラクター画像', value: '50クレジット/回', checked: true },
        soraVideo: { label: 'HyperSell動画', value: '150クレジット/回', checked: true },
        digitalHuman: { label: 'SuperIP動画', value: '未解放', locked: true },
        maxDuration: { label: '最大時間', value: '対象外', locked: true },
        hdEnhance: { label: 'HD高画質化', value: '対象外', locked: true },
        voiceClone: { label: '音声作成', value: '対象外', locked: true },
        watermark: { label: 'ウォーターマークなし書き出し', value: 'ウォーターマークあり', locked: true },
        priorityQueue: { label: '優先キュー', value: '標準', locked: true },
        apiAccess: { label: 'APIアクセス', value: '対象外', locked: true },
      },
    },
    creator: {
      name: 'クリエイター',
      tagline: 'プロ',
      description: '個人クリエイターやコンテンツチームに最適',
      cta: '購読する',
      price: { monthly: 29, yearly: 290 },
      credits: '30,000',
      features: {
        scriptGen: { label: 'スクリプト生成', value: '無制限', unlimited: true },
        characterImage: { label: 'キャラクター画像', value: '50クレジット/回', checked: true },
        soraVideo: { label: 'HyperSell動画', value: '150クレジット/回', checked: true },
        digitalHuman: { label: 'SuperIP動画', value: '70クレジット/秒', checked: true },
        maxDuration: { label: '最大時間', value: '2分', checked: true },
        hdEnhance: { label: 'HD高画質化', value: '800クレジット/回', discount: true },
        voiceClone: { label: '音声作成', value: '3000クレジット/音声', checked: true },
        watermark: { label: 'ウォーターマークなし書き出し', value: 'あり', checked: true },
        priorityQueue: { label: '優先キュー', value: '高速', checked: true },
        apiAccess: { label: 'APIアクセス', value: '対象外', locked: true },
      },
    },
    business: {
      name: 'ビジネス',
      tagline: 'コマーシャル',
      description: '代理店や成長中のECブランド向け',
      cta: 'ビジネスにする',
      price: { monthly: 99, yearly: 990 },
      credits: '120,000',
      popular: true,
      features: {
        scriptGen: { label: 'スクリプト生成', value: '無制限', unlimited: true },
        characterImage: { label: 'キャラクター画像', value: '無料・無制限', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell動画', value: '150クレジット/回', checked: true },
        digitalHuman: { label: 'SuperIP動画', value: '70クレジット/秒', checked: true },
        maxDuration: { label: '最大時間', value: '10分', checked: true },
        hdEnhance: { label: 'HD高画質化', value: '500クレジット（40%オフ）', discount: true },
        voiceClone: { label: '音声作成', value: '最初の1つ無料', gift: true },
        watermark: { label: 'ウォーターマークなし書き出し', value: 'あり', checked: true },
        priorityQueue: { label: '優先キュー', value: '高速', checked: true },
        apiAccess: { label: 'APIアクセス', value: '対象外', locked: true },
      },
    },
    enterprise: {
      name: 'エンタープライズ',
      tagline: '企業',
      price: 'カスタム',
      description: '大規模チーム・プラットフォーム向けのカスタムソリューション',
      cta: '営業に問い合わせる',
      credits: 'カスタム枠',
      features: {
        scriptGen: { label: 'スクリプト生成', value: '無制限', unlimited: true },
        characterImage: { label: 'キャラクター画像', value: '無料・無制限', free: true, unlimited: true },
        soraVideo: { label: 'HyperSell動画', value: '150クレジット/回', checked: true },
        digitalHuman: { label: 'SuperIP動画', value: 'カスタムレート', custom: true },
        maxDuration: { label: '最大時間', value: '無制限/カスタム', unlimited: true },
        hdEnhance: { label: 'HD高画質化', value: 'カスタム割引', discount: true, custom: true },
        voiceClone: { label: '音声作成', value: '都度付与', gift: true, custom: true },
        watermark: { label: 'ウォーターマークなし書き出し', value: 'あり', checked: true },
        priorityQueue: { label: '優先キュー', value: '最高優先度', checked: true },
        apiAccess: { label: 'APIアクセス', value: 'フルAPI', checked: true },
      },
    },
  },
  fullComparison: {
    title: '全機能比較',
    subtitle: '最適なプランを選んで、より多くのクリエイティブを実現',
    back: '戻る',
  },
  comparison: {
    title: 'プランを比較',
    subtitle: '今の段階に合ったプランを確認。いつでもアップグレード/ダウングレード可能です。',
    featureLabel: '機能',
    customLabel: 'カスタム',
    features: {
      monthlyPrice: '月額料金',
      monthlyCredits: '毎月のクレジット',
      signupBonus: '0（登録ボーナス200）',
      scriptGeneration: 'スクリプト生成',
      roleGeneration: 'ロール生成',
      characterImage: 'キャラクター画像',
      video: 'HyperSell動画',
      digitalHuman: 'SuperIP動画',
      durationLimit: '時間上限',
      hdEnhancement: 'HD高画質化',
      voiceCloning: '音声作成',
      watermarkFree: 'ウォーターマークなし書き出し',
      priorityQueue: '優先キュー',
      apiAccess: 'APIアクセス',
      unlimited: '無制限',
      freeLimit: '無料（1日50回）',
      unlimitedDemand: '無制限/オンデマンド',
      creditsPerImage: '50クレジット/画像',
      creditsPerVideo: '150クレジット/動画',
      creditsPerSecond: '70クレジット/秒',
      creditsPerEnhance: '800クレジット/回',
      creditsPerVoice: '3000クレジット/音声',
      freeUnlimited: '無料・無制限',
      customRate: 'カスタムレート',
      twoMinutes: '2分',
      tenMinutes: '10分',
      customUnlimited: 'カスタム/無制限',
      discountEnhance: '500クレジット（割引）',
      customDiscount: 'カスタム割引',
      firstFree: '最初の1つ無料',
      batchGift: '一括付与',
    },
  },
  credits: {
    title: 'VGOTのクレジットの仕組み',
    description: 'VGOTはクレジット制を採用しており、個々のAPIコストを気にする必要はありません。操作によって消費量が異なります。例：',
    examples: {
      soraVideo: 'HyperSell動画を生成',
      enhance: '動画を高画質化・アップスケール',
      talkingAvatar: 'Super IPのトーキングアバターを作成',
    },
    footnote: 'プランには毎月のクレジット枠が含まれます。キャンペーンやローンチで一時的に増やしたい場合は、追加クレジットを購入できます。',
  },
  faq: {
    title: '料金に関するFAQ',
    q1: {
      question: 'クレジットはどう消費されますか？',
      answer: 'HyperSell動画は1本150クレジット、デジタルヒューマンは1秒あたり70クレジット、キャラクター画像は50クレジット、HD高画質化はプランにより500〜800クレジットです。詳しくはダッシュボードをご確認ください。',
    },
    q2: {
      question: 'クレジットが足りなくなったら？',
      answer: 'VGOT内でいつでも追加クレジットパックを購入できます。クレジットは失効しないため、繁忙期に備えて貯めておけます。',
    },
    q3: {
      question: 'プランのアップグレードやダウングレードはできますか？',
      answer: 'はい。いつでもサブスクリプションを変更できます。アップグレードは即時、ダウングレードは次回の請求サイクルから適用されます。',
    },
    q4: {
      question: '「画像生成が無料・無制限」とは？',
      answer: 'ビジネス/エンタープライズでは、クレジットを消費せずに必要なだけキャラクター画像を生成できます。アバターライブラリの構築に最適です。',
    },
    q5: {
      question: '生成した動画の商用利用権はありますか？',
      answer: '有料プラン（クリエイター、ビジネス、エンタープライズ）には、生成・書き出ししたコンテンツの商用利用権が含まれます。',
    },
  },
};

export const pricingTranslations = { en, 'zh-CN': zhCN, 'zh-TW': zhTW, es, ja };
